export function getContrastTextColor(hex: string): '#000000' | '#FFFFFF' {
    // Normalize hex: remove "#" and expand short form (e.g. #abc => #aabbcc)
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(c => c + c)
            .join('');
    }

    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Use luminance formula per WCAG
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // If luminance is high, use black text; otherwise, white text
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

export function getTenTimesLighterColor(hex: string, lighterTimes: number = 10): string {
    // Normalize hex: remove "#" and expand short form (e.g. #abc => #aabbcc)
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(c => c + c)
            .join('');
    }

    // Convert to RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Increase brightness by 10 times
    const newR = Math.min(255, r * lighterTimes);
    const newG = Math.min(255, g * lighterTimes);
    const newB = Math.min(255, b * lighterTimes);

    // Convert back to hex
    return `#${((1 << 24) + (newR << 16) + (newG << 8) + newB).toString(16).slice(1)}`;
}

export const LABEL_BORDER_COLOR = '#454545';

export function lightenDarkenColor(color: string, amt: number): string {
    let col = parseInt(color, 16);
    return (
        ((col & 0x0000ff) + amt) |
        ((((col >> 8) & 0x00ff) + amt) << 8) |
        (((col >> 16) + amt) << 16)
    ).toString(16);
}
